/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Number_SignInputs */



/**
* | output |
* | --- |
* | "#" |
*
* @param {Ccsl_Export_Header_Number_SignInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_number_sign = /** @type {((inputs?: Ccsl_Export_Header_Number_SignInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Number_SignInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("#")
	if (locale === "de") return /** @type {LocalizedString} */ ("#")
	if (locale === "it") return /** @type {LocalizedString} */ ("#")
	if (locale === "ru") return /** @type {LocalizedString} */ ("#")
	if (locale === "es") return /** @type {LocalizedString} */ ("#")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("#")
	if (locale === "ja") return /** @type {LocalizedString} */ ("#")
	if (locale === "hi") return /** @type {LocalizedString} */ ("#")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("#")
	return /** @type {LocalizedString} */ ("#")
});